import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { GlobalConstants } from "../../constants/GlobalConstants";
import LmsTabPages from "../ui/LmsTabPages";

const MainTable = () => {
  const actionsButtons = ["add", "export"];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="funds/loan-fund-allocations"
    sortable={["Created On"]}
    groupBy={["loan"]}
  />;
};

const addFormFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Borrower", "metadata/list-borrower-organizations", { name: "borrowerOrganizationId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Special Purpose Entity", "orgs/list-special-purpose-entities", { dependencyField: "borrowerOrganizationId" })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan", "loans/list-borrower-loans", { name: "loanId", dependencyField: "borrowerOrganizationId", dependencyFieldQuery: "borrowerOrganizationId",  required: true })]);
  return myForm;
};

const AddFundAllocationForm = () => {
  const myForm = addFormFields(new BCFormController({}, { submitSuffix: "funds/fund-allocation" }));

  const formActions = [{
    text: "Delete Previous Fund Allocations and Randomize", action: "save", icon: GlobalConstants.Icons.CARET_UP
  }, "close"];

  return <LmsFormGenerator myForm={myForm} actions={formActions}/>;
};

const addEditFormFields = (myForm, id="") => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan", `loans/list-borrower-loans?borrowerOrganizationId=${id}`, { required: true, disabled: true }),
    myForm.getDropdownField("Fund", "", { required: true, disabled: true })
  ]);
  myForm.addCenteredGroup([
    myForm.getNumberField("Randomization Round", { required: true }),
    myForm.getNumberField("Ranking", { required: true })
  ]);
  myForm.addCenteredGroup([
    myForm.getCurrencyField("Available Capacity", { required: true }),
    myForm.getInputField("Percent Available Capacity", { required: true, fieldType: "percent" })
  ]);
  myForm.addCenteredGroup([
    myForm.getInputField("Weighting Factor", { required: true, fieldType: "float" }),
    myForm.getInputField("Resultant Weighting", { required: true, fieldType: "float" }),
  ]);
  myForm.addCenteredGroup([
    myForm.getInputField("Random Number", { required: true, fieldType: "float" }),
    myForm.getCheckboxField("Accepted"),
  ]);
  myForm.addCenteredGroup([
    myForm.getCheckboxField("Accepted Conditionally", { required: true, fieldType: "float" }),
    myForm.getCalendarField("Accepted On"),
  ]);
  myForm.addCenteredGroup([
    myForm.getCheckboxField("Has Voted"),
    myForm.getCheckboxField("Is Active"),
  ]);
  myForm.addCenteredGroup([
    myForm.getTextareaField("Description")
  ]);
  return myForm;
};

const EditFundAllocationForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`funds/loan-fund-allocation/${id}`);
  const myForm = addEditFormFields(new BCFormController(data, { initIsDisabled: true, blankWidth: 3 }), id);

  const tabPages = {
    "Polling Result": <LmsTable actionButtons={["export"]} apiSuffix={`funds/polling-result/${id}`} sortable={["Created On"]}/>
  };

  return <React.Fragment>
    <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={["close"]}/>
    <LmsTabPages tabPages={tabPages}/>;
  </React.Fragment>;
};

const LmsFundsFundAllocation = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <MainTable/>}
    {isAdd && <AddFundAllocationForm/>}
    {isEdit && <EditFundAllocationForm id={id}/>}
  </React.Fragment>);
};

export default LmsFundsFundAllocation;